import React, { useState, useRef } from "react";
import SuccessScreen from "../screens/SuccessSreen";

const FormContext = React.createContext({});

const FormProvider = ({ children, ...props }) => {
  const [ticketId, setTicketId] = useState(null);
  const [location, setLocation] = useState(null);
  const [showSuccess, setShowSuccess] = useState(false);
  let sigPad = useRef({})
  return (
    <FormContext.Provider
      value={{
        ticketId,
        location,
        showSuccess,
        setShowSuccess,
        setLocation,
        setTicketId,
        sigPad,
        ...props,
      }}
    >
      {children}
      {ticketId && <SuccessScreen />}
    </FormContext.Provider>
  );
};

export const useFormContext = () => {
  const context = React.useContext(FormContext);
  if (!context) {
    throw new Error("use `useFormContext` inside `FormProvider` ");
  }
  return context;
};

export default FormProvider;
